import { Navigate } from "react-router-dom";
import { useAuth } from "./auth";

export const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, isChecking } = useAuth();

  if (isChecking) {
    return <div data-testid="protected-route-loading" className="private-loading-screen">Caricamento area riservata...</div>;
  }

  if (!user) {
    return <Navigate to="/area-riservata/login" replace />;
  }

  if (allowedRoles.length && !allowedRoles.includes(user.role)) {
    return <Navigate to="/area-riservata" replace />;
  }

  return children;
};